
import { JGET, JPOST, PARAMS, TGET } from 'iotera-base/webservice'
import { isEitherNone, isNone } from 'iotera-base/object';
import Result from 'iotera-base/result';
import { safeDeepGet } from 'iotera-base/json';

export const BASE_URL = "http://demo.iotera.io:8000/p/service/web";
//export const BASE_URL = "http://localhost:8080/service/web";

const TIMEOUT = 30000;
const REGISTER_TIMEOUT = 60000;
const CREATE_APPLICATION_TIMEOUT = 60000;
const CREATE_GATEWAY_END_TIMEOUT = 60000;

// Base
export function DOMAIN_POST_W_TIMEOUT(url, domain, body, timeout) {
    
    if (isNone(domain)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }
    
    let headers = {
        'Iotera-Application-Domain': domain
    }
    const wparam = {
        url,
        headers, 
        body,
        timeout
    }
    return JPOST(wparam);
}

export function DOMAIN_POST(url, domain, body) {
    return DOMAIN_POST_W_TIMEOUT(url, domain, body, TIMEOUT);
}

export function TENANT_GET(url, tenantToken) {

    let id = safeDeepGet(tenantToken, ['id']);
    let token = safeDeepGet(tenantToken, ['token']);
    
    if (isEitherNone(id, token)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }

    let headers = {
        'Iotera-Tenant-Id': id,
        'Iotera-Tenant-Web-Token': token
    }
    const wparam = {
        url,
        headers,
        timeout: TIMEOUT
    }
    return JGET(wparam);
}

export function TENANT_POST_W_TIMEOUT(url, tenantToken, body, timeout) {
    
    let id = safeDeepGet(tenantToken, ['id']);
    let token = safeDeepGet(tenantToken, ['token']);

    if (isEitherNone(id, token)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }
    
    let headers = {
        'Iotera-Tenant-Id': id,
        'Iotera-Tenant-Web-Token': token
    }
    const wparam = {
        url,
        headers,
        body,
        timeout
    }
    return JPOST(wparam);
}

export function TENANT_POST(url, tenantToken, body) {
    return TENANT_POST_W_TIMEOUT(url, tenantToken, body, TIMEOUT);
}

export function APP_GET(url, appToken) {
    
    let id = safeDeepGet(appToken, ['id']);
    let token = safeDeepGet(appToken, ['token']);
    let domain = safeDeepGet(appToken, ['domain']);
    let isTenant = safeDeepGet(appToken, ['isTenant']);

    if (isEitherNone(id, token, domain, isTenant)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }
    
    let headers;
    if (isTenant) {
        headers = {
            'Iotera-Tenant-Id': id,
            'Iotera-Tenant-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    } else {
        headers = {
            'Iotera-Account-Id': id,
            'Iotera-Account-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    }
    const wparam = {
        url,
        headers,
        timeout: TIMEOUT
    }
    return JGET(wparam);
}

export function APP_TGET(url, appToken) {
    
    let id = safeDeepGet(appToken, ['id']);
    let token = safeDeepGet(appToken, ['token']);
    let domain = safeDeepGet(appToken, ['domain']);
    let isTenant = safeDeepGet(appToken, ['isTenant']);

    if (isEitherNone(id, token, domain, isTenant)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }
    
    let headers;
    if (isTenant) {
        headers = {
            'Iotera-Tenant-Id': id,
            'Iotera-Tenant-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    } else {
        headers = {
            'Iotera-Account-Id': id,
            'Iotera-Account-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    }
    const wparam = {
        url,
        headers,
        timeout: TIMEOUT
    }
    return TGET(wparam);
}


export function APP_POST_W_TIMEOUT(url, appToken, body, timeout) {
    
    let id = safeDeepGet(appToken, ['id']);
    let token = safeDeepGet(appToken, ['token']);
    let domain = safeDeepGet(appToken, ['domain']);
    let isTenant = safeDeepGet(appToken, ['isTenant']);

    if (isEitherNone(id, token, domain, isTenant)) {
        return {
            code: Result.HTTP.UNAUTHORIZED,
            text: Result.HTTP.Message.get(Result.HTTP.UNAUTHORIZED),
            headers: null,
            body: null
        }
    }
    
    let headers;
    if (isTenant) {
        headers = {
            'Iotera-Tenant-Id': id,
            'Iotera-Tenant-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    } else {
        headers = {
            'Iotera-Account-Id': id,
            'Iotera-Account-Web-Token': token,
            'Iotera-Application-Domain': domain
        }
    }
    const wparam = {
        url,
        headers,
        body,
        timeout
    }
    return JPOST(wparam);
}

export function APP_POST(url, appToken, body) {
    return APP_POST_W_TIMEOUT(url, appToken, body, TIMEOUT);
}

// Authentication
export function registerTenant(first, last, tenant_name, username, email, pass, passv) {
    let url = BASE_URL + "/tenant/account/auth/register";
    let body = {
        "first": first,
        "last": last,
        "tenant_name": tenant_name,
        "username": username,
        "email": email,
        "pass": pass,
        "passv": passv
    }
    const wparam = {
        url,
        body,
        timeout: REGISTER_TIMEOUT
    }
    return JPOST(wparam);
}

export function loginTenant(input, pass) {
    let url = BASE_URL + "/tenant/account/auth/login";
    let body = {
        "input": input,
        "pass": pass
    }
    const wparam = {
        url,
        body,
        timeout: TIMEOUT
    }
    return JPOST(wparam);
}

// Account Profile
export function tenantAccountSettingRead(tenantToken) {
    let url = BASE_URL + "/tenant/account/setting/get";
    return TENANT_GET(url, tenantToken);
}

export function tenantAccountSettingUpdate(tenantToken, username, first, last) {
    let url = BASE_URL + "/tenant/account/setting/edit";
    let body = {
        "username": username,
        "first": first,
        "last": last
    }
    return TENANT_POST(url, tenantToken, body);
}

// Tenant
export function tenantUpdate(tenantToken, name, urlu, description, picture) {
    let url = BASE_URL + "/tenant/edit";
    let body = {
        "name": name,
        "url": urlu,
        "description": description,
        "picture": picture
    }
    return TENANT_POST(url, tenantToken, body);
}

// Application
export function applicationListAll(tenantToken) {
    let url = BASE_URL + "/application/list";
    return TENANT_GET(url, tenantToken);
}

export function applicationCreate(tenantToken, name, domain) {
    let url = BASE_URL + "/application/add";
    let body = {
        "name": name,
        "domain": domain
    }
    return TENANT_POST_W_TIMEOUT(url, tenantToken, body, CREATE_APPLICATION_TIMEOUT);
}

export function applicationUpdate(appToken, domain, name, urlu, description, picture) {
    let url = BASE_URL + "/application/edit";
    let body = {
        "domain": domain,
        "name": name,
        "url": urlu,
        "description": description,
        "picture": picture
    }
    return APP_POST(url, appToken, body);
}

// Provision
export function deviceProvisionGen(appToken) {
    let url = BASE_URL + "/device/provision/gen";
    let body = {}
    return APP_POST(url, appToken, body);
}

export function deviceProvisionCheck(appToken, credentialsToken) {
    let url = BASE_URL + "/device/provision/check";
    let body = {
        "credentials_token": credentialsToken
    }
    return APP_POST(url, appToken, body);
}

// Endpoint
export function deviceGatewayAdd(appToken, credentialsToken, serial_number, label, firmware, locations, sensors, tags, components) {
    let url = BASE_URL + "/device/gateway/end/create";
    let body = {
        "credentials_token": credentialsToken,
        "serial_number": serial_number,
        "label": label,
        "firmware": firmware,
        "locations": locations,
        "sensors": sensors,
        "tags": tags,
        "components": components
    }
    return APP_POST_W_TIMEOUT(url, appToken, body, CREATE_GATEWAY_END_TIMEOUT);
}

export function deviceListAll(appToken) {
    let url = BASE_URL + "/device/list";
    return APP_GET(url, appToken);
}

export function deviceListWeb(appToken) {
    let url = BASE_URL + "/device/list/web";
    return APP_GET(url, appToken);
}

export function deviceDataWeb(appToken, id, component, time) {
    let url = BASE_URL + "/device/data/read/web/id/" + id;
    url += PARAMS(
        {
            component: component,
            time: time
        }
    );
    return APP_GET(url, appToken);
}
